module.exports = __webpack_public_path__ + "static/media/contact.028e814d.jpg";